import type { AgentTaskQueueItem, TaskPriority } from '@erp/rpc';

export const QUEUE_PRIORITIES = [
  'urgent',
  'high',
  'medium',
  'low',
] as const satisfies readonly TaskPriority[];

/** "Run next" is a no-op for a task that is already first in line. */
export function isAlreadyNext(task: Pick<AgentTaskQueueItem, 'position'>) {
  return task.position === 1;
}

export type ProcedureLockState = 'current' | 'behind' | 'unknown';

export function procedureLockState(
  lock: AgentTaskQueueItem['procedureLocks'][number],
): ProcedureLockState {
  if (lock.publishedVersion == null) return 'unknown';
  return lock.lockedVersion === lock.publishedVersion ? 'current' : 'behind';
}
